/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-26T09:20:14.877
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHousePutaway,
	listRentHousePutawayInit,
	listRentHousePutawayByAuthorizations,
	deleteRentHousePutaway
	
} from '@api/rentmanage/RentHousePutaway';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHousePutaway({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePutaway(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHousePutawayByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePutawayByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHousePutawayInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHousePutawayInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						state.CompoundEntities.rowFunctionAuthorization = res.rowFunctionAuthorization;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHousePutaway({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHousePutaway({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
